import { StoreAction } from "../../../types/store"
import { Playlogs } from "../lib/playlogs"

export type SetPlayLogsAction = StoreAction & { playlogs: Playlogs[] }
export const SET_PLAY_LOGS = "SET_PLAY_LOGS"
export const setPlayLogs = (playlogs: Playlogs[]): SetPlayLogsAction => ({
  type: SET_PLAY_LOGS,
  playlogs,
})
